import { motion } from 'motion/react';
import { Play, ArrowRight } from 'lucide-react';
import { GlassCard } from '../ui/GlassCard';
import { Link } from 'react-router-dom';

export const ContactSection = () => {
  return (
    <section id="contact" className="relative z-10 min-h-screen flex items-center justify-center py-20 overflow-hidden">
      <div className="max-w-4xl mx-auto px-6 w-full">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h2 className="text-4xl md:text-5xl font-display font-bold text-white mb-6 text-center">
            Odbierz dostęp do <span className="text-primary">darmowych materiałów</span>
          </h2>
          <p className="text-text-muted mb-12 text-lg text-center max-w-2xl mx-auto">
            Obejrzyj darmowe lekcje i dowiedz się, jak zacząć zarabiać z AI już dziś.
            Poznaj nasze metody i sprawdź, czy to jest dla Ciebie.
          </p>

          <GlassCard className="p-2 overflow-hidden">
            <div className="aspect-video bg-surface rounded-xl flex items-center justify-center relative overflow-hidden group cursor-pointer">
              <div className="absolute inset-0 bg-gradient-to-br from-primary/20 to-accent/20" />
              <div className="relative z-10 flex flex-col items-center gap-4">
                <div className="w-20 h-20 bg-primary rounded-full flex items-center justify-center shadow-[0_0_40px_rgba(var(--color-primary),0.5)] group-hover:scale-110 transition-transform">
                  <Play className="w-8 h-8 text-primary-foreground fill-current ml-1" />
                </div>
                <span className="text-text-main font-bold text-lg">Obejrzyj darmowe lekcje</span>
                <span className="text-text-muted text-sm">Poznaj metodologię Akademii Milionerów</span>
              </div>
            </div>
          </GlassCard>

          <div className="text-center mt-10">
            <Link to="/rejestracja" className="inline-flex items-center gap-2 px-8 py-4 bg-primary text-primary-foreground font-bold uppercase tracking-wider rounded-full hover:bg-primary/90 transition-all shadow-[0_0_30px_rgba(var(--color-primary),0.4)]">
              Zarejestruj się gratis
              <ArrowRight className="w-4 h-4" />
            </Link>
            <p className="text-text-muted text-sm mt-4">Nie wymagamy karty kredytowej</p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
